import { useParameterStore } from '@/frontend/store/ParameterStore';
import { HelpIcon } from '@/frontend/SVGs/HelpIcon';
import { I18n } from '@/i18n/I18n';
import { DataTypes } from '@/types/itemReferenceTypes';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { useShallow } from 'zustand/react/shallow';
import { ParameterSourceLink } from './ParameterSourceLink';

export function ReferenceLabel(props: { consumerId: string }) {
  const { consumerId } = props;
  const reference = useParameterStore (useShallow(state => state.references.find(ref => ref.dataConsumerId === consumerId && ref.dataConsumerType === DataTypes.Parameter)));
  const sourceParam = useParameterStore(useShallow(state => state.parameters.find(param => param.id === reference?.dataSourceId)));

  if (!reference || reference.isInterpolated) return null;

  if (reference.dataSourceType === DataTypes.Parameter && sourceParam) {
    return <ParameterSourceLink parameter={sourceParam} reference={reference}  />;
  }

  return null;
}

export function ParameterInfoTooltip(props: { consumerId: string, description?: string }) {
  const { consumerId, description } = props;
  const reference = useParameterStore(useShallow(state => state.references.find(ref => ref.dataConsumerId === consumerId && ref.dataConsumerType === DataTypes.Parameter)));
  const sourceParam = useParameterStore(useShallow(state => state.parameters.find(param => param.id === reference?.dataSourceId)));

  return (
    <div className='d-flex gap-2 pb-1 ps-1 text-muted text-nowrap'>
      {description && (
        <OverlayTrigger
          placement='top'
          overlay={
            <Popover>
              <Popover.Header as="h3">{I18n.get('description')}</Popover.Header>
              <Popover.Body>
                <p>{description}</p>
              </Popover.Body>
            </Popover>
          }
        >
          <div className='pt-1'>
            <HelpIcon />
          </div>
        </OverlayTrigger>
      )}
      { reference?.dataSourceType === DataTypes.Parameter && sourceParam &&
        <ParameterSourceLink parameter={sourceParam} reference={reference}  />
      }
    </div>
  );
}
